import { makeStyles, shorthands } from '@fluentui/react-components';
import { FC } from 'react';
import { OpenAiLogo } from './OpenAiLogo';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        ...shorthands.gap('1rem'),
        // Add transition to match drawer animation timing
        ...shorthands.transition('all', '0.4s', 'ease-in-out'),
    },
    title: {
        lineHeight: '30px',
        ...shorthands.margin('0px'),
    },
});

export interface AppLogoWithTitleProps {
    theme?: 'light' | 'dark';
    collapsed?: boolean;
}

const AppLogoWithTitle: FC<AppLogoWithTitleProps> = ({ theme, collapsed }) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <OpenAiLogo theme={theme} size={collapsed ? 'small' : 'medium'} />
        </div>
    );
};

export default AppLogoWithTitle;
